module.exports = __webpack_public_path__ + "img/broodhuys__ok.968c112f.jpg";